import { useEffect } from 'react';
import { noop } from 'lodash';
import { useUnifiedTradesService } from '#/unified-rfqs/contexts/unified-trades';
import { useObMatchingQuoteFeatureFlag } from '#/feature-flags/context';

/**
 * We need to fetch trade history on start to make sure latest trades
 * are available and trade detection has the required data to run.
 */
export default function useFetchTradeHistoryOnStart() {
  const { fetcher } = useUnifiedTradesService();
  const isObMatchingEnabled = useObMatchingQuoteFeatureFlag();

  useEffect(() => {
    if (!isObMatchingEnabled) return;
    fetcher.fetchLatest({}, noop);
  }, [fetcher, isObMatchingEnabled]);
}
